import services from '@/http'
import * as types from './mutations-types'

export const ActionListingProtocols = ({commit}, payload) => {
	return services.protocols.listing(payload).then(res => {
		let paginator = {};
		paginator.total = res.data.data.total;
		paginator.current_page = res.data.data.current_page;
		paginator.per_page = res.data.data.per_page;
		commit(types.SET_PAGINATOR, paginator);

		let listing =  res.data.data.data;
		commit(types.SET_LISTING,  listing);
	});
}
